import axios from "axios";

axios.defaults.validateStatus = () => true;

const apiAbis = axios.create({
  baseURL: process.env.REACT_APP_URL_ABIS,
  headers: {
    usuario: "GTIWSUSER",
    senha: "11TB#idnet%2020",
    key: "Pamela.intranet.sds.pe.gov.br",
  },
});

export function getDadosCivil(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(
    `wsCivil/ObterDadosCidadaoCivil/${NumeroPessoa}`,
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
  return response;
}

export function getFoto3x4(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(`wsCivil/ObterFoto3x4/${NumeroPessoa}`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
  return response;
}

// eslint-disable-next-line camelcase
export function getIdt(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.post(
    `wsCivil/ObterDocumentos`,
    {
      v_iPessoa: NumeroPessoa,
      v_sMnemonicoSubTipoImagem: "RG",
    },
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
  return response;
}

export default apiAbis;
